/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
// import './App.css';
import styles from './App.module.css';

// components
// components
import Header from '../header/Header';
import About from '../header/About';
import Footer from '../footer/Footer';
import Main from '../main/Main';
import ExampleHeader from '../main/ExampleHeader';
import data from '../../logic/data';

/*****************************************
 * * CREATE APP COMPONENT
 *****************************************/

class App extends Component {
  
  state = {
    exampleIdx: data.exampleIdx
  }

  setExample = val => {
    console.log('[EXAMPLE]', val);
    this.setState({
      exampleIdx: val,
    });
  };

  render() {
    return (
      <div className={styles.gridContainer}>
        <Header />
        <About />

        <ExampleHeader exampleIdx={this.state.exampleIdx} />
        <Main
          exampleIdx={this.state.exampleIdx}
          onExampleChange={this.setExample}
        />

        <Footer />
      </div>
    );
  }
}

export default App;
